"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiManager = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const CoreConfiguration_1 = __importDefault(require("../config/CoreConfiguration"));
const utils_1 = require("../containers/ConfigProvider/utils");
const defaultParams = { private: false };
const getConfiguration = (params = defaultParams) => {
    const configuration = {
        basePath: (0, utils_1.getApiUrl)(),
    };
    if (params === null || params === void 0 ? void 0 : params.private) {
        configuration.baseOptions = {
            withCredentials: true,
        };
    }
    return new betweb_openapi_axios_1.Configuration(configuration);
};
const buildApi = (clazz, params) => {
    return CoreConfiguration_1.default.getInstance().apiBuilder.build(clazz, getConfiguration(params));
};
const apisMap = {
    [betweb_openapi_axios_1.ProfilesApi.name]: 'ProfilesApi',
    [betweb_openapi_axios_1.BetsApi.name]: 'BetsApi',
    [betweb_openapi_axios_1.SportsApi.name]: 'SportsApi',
    [betweb_openapi_axios_1.OutcomeCategoriesApi.name]: 'OutcomeCategoriesApi',
    [betweb_openapi_axios_1.MarketsApi.name]: 'MarketsApi',
    [betweb_openapi_axios_1.CurrenciesApi.name]: 'CurrenciesApi',
    [betweb_openapi_axios_1.MarketCategoriesApi.name]: 'MarketCategoriesApi',
    [betweb_openapi_axios_1.MarketGroupsApi.name]: 'MarketGroupsApi',
    [betweb_openapi_axios_1.EventTagsApi.name]: 'EventTagsApi',
    [betweb_openapi_axios_1.EntityTagsApi.name]: 'EntityTagsApi',
    [betweb_openapi_axios_1.SystemCurrenciesApi.name]: 'SystemCurrenciesApi',
    [betweb_openapi_axios_1.MatchPhasesApi.name]: 'MatchPhasesApi',
    [betweb_openapi_axios_1.EventProbabilitiesApi.name]: 'EventProbabilitiesApi',
    [betweb_openapi_axios_1.BannersApi.name]: 'BannersApi',
    [betweb_openapi_axios_1.PaymentMethodGroupsApi.name]: 'PaymentMethodGroupsApi',
    [betweb_openapi_axios_1.SearchApi.name]: 'SearchApi',
    [betweb_openapi_axios_1.LogosApi.name]: 'LogosApi',
    [betweb_openapi_axios_1.TournamentsApi.name]: 'TournamentsApi',
    [betweb_openapi_axios_1.PlayersApi.name]: 'PlayersApi',
    [betweb_openapi_axios_1.SportsCountersApi.name]: 'SportsCountersApi',
    [betweb_openapi_axios_1.LanguagesApi.name]: 'LanguagesApi',
    [betweb_openapi_axios_1.GameVendorSettingsApi.name]: 'GameVendorSettingsApi',
    [betweb_openapi_axios_1.EventsApi.name]: 'EventsApi',
    [betweb_openapi_axios_1.BroadcastApi.name]: 'BroadcastApi',
    [betweb_openapi_axios_1.AccountsApi.name]: 'AccountsApi',
    [betweb_openapi_axios_1.BasketsApi.name]: 'BasketsApi',
    [betweb_openapi_axios_1.PaymentsApi.name]: 'PaymentsApi',
    [betweb_openapi_axios_1.WithdrawalsApi.name]: 'WithdrawalsApi',
    [betweb_openapi_axios_1.VerificationsApi.name]: 'VerificationsApi',
    [betweb_openapi_axios_1.VirtualGamesApi.name]: 'VirtualGamesApi',
    [betweb_openapi_axios_1.FavoriteEventsApi.name]: 'FavoriteEventsApi',
    [betweb_openapi_axios_1.EventResultsApi.name]: 'EventResultsApi',
    [betweb_openapi_axios_1.LoyaltyApi.name]: 'LoyaltyApi',
    [betweb_openapi_axios_1.MessagesApi.name]: 'MessagesApi',
    [betweb_openapi_axios_1.ControlQuestionsApi.name]: 'ControlQuestionsApi',
    [betweb_openapi_axios_1.CaptchaProvidersApi.name]: 'CaptchaProvidersApi',
    [betweb_openapi_axios_1.VirtualCategoriesApi.name]: 'VirtualCategoriesApi',
};
const getIsPrivateApi = (apiName) => {
    const privateApiNames = [
        betweb_openapi_axios_1.ProfilesApi.name,
        betweb_openapi_axios_1.AccountsApi.name,
        betweb_openapi_axios_1.VirtualGamesApi.name,
        betweb_openapi_axios_1.BetsApi.name,
        betweb_openapi_axios_1.LoyaltyApi.name,
        betweb_openapi_axios_1.ControlQuestionsApi.name,
        betweb_openapi_axios_1.PaymentsApi.name,
        betweb_openapi_axios_1.WithdrawalsApi.name,
        betweb_openapi_axios_1.VerificationsApi.name,
        betweb_openapi_axios_1.BasketsApi.name,
        betweb_openapi_axios_1.BroadcastApi.name,
        betweb_openapi_axios_1.FavoriteEventsApi.name,
        betweb_openapi_axios_1.MessagesApi.name,
        betweb_openapi_axios_1.EventsApi.name,
    ];
    return privateApiNames.includes(apiName);
};
class ApiManager {
    static getApi(clazz) {
        const apiKey = apisMap[clazz.name];
        const isPrivate = getIsPrivateApi(clazz.name);
        if (!apiKey) {
            return buildApi(clazz, { private: isPrivate });
        }
        if (!ApiManager.apis[apiKey]) {
            ApiManager.apis[apiKey] = buildApi(clazz, { private: isPrivate });
        }
        return ApiManager.apis[apiKey];
    }
}
exports.ApiManager = ApiManager;
ApiManager.apis = {};
//# sourceMappingURL=index.js.map